import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    attrs: {
      inline: true,
      size: "mini"
    }
  }, [_c("el-form-item", [_c("el-input", {
    attrs: {
      placeholder: "请输入提单号"
    },
    model: {
      value: _vm.searchForm.waybillExtractIdentity,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "waybillExtractIdentity", $$v);
      },
      expression: "searchForm.waybillExtractIdentity"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.search
    }
  }, [_c("i", {
    staticClass: "fa fa-search"
  }), _vm._v(" 查询")])], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.queryLoading,
      expression: "queryLoading"
    }],
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      data: _vm.tableData,
      stripe: "",
      border: "",
      "row-key": "id",
      "element-loading-text": "正在努力加载中..."
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "序号",
      type: "index",
      width: "50"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            size: "mini",
            type: "warning"
          },
          on: {
            click: function click($event) {
              return _vm.edit(scope.row.id);
            }
          }
        }, [_vm._v("详情")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "waybillExtractIdentity",
      label: "提单号",
      "show-overflow-tooltip": "",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "handle",
      label: "操作内容",
      "show-overflow-tooltip": "",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_vm._v(_vm._s(scope.row.handle))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "oldContent",
      label: "修改前",
      "show-overflow-tooltip": "",
      width: "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_vm._v(_vm._s(_vm.jsonToContent(scope.row.oldContent)))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "newContent",
      label: "修改后",
      "show-overflow-tooltip": "",
      width: "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_vm._v(_vm._s(_vm.jsonToContent(scope.row.newContent)))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "userNickname",
      label: "操作人",
      "show-overflow-tooltip": "",
      width: "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.handleUserType == "admin" ? _c("div", [_vm._v("管理员")]) : _vm._e(), scope.row.handleUserType == "mng_user_category_hd_merchant" ? _c("div", [_vm._v(_vm._s(scope.row.merchantNickname) + " " + _vm._s(scope.row.merchantBusinessLicenseName))]) : _vm._e(), scope.row.handleUserType == "mng_user_category_hd_driver" ? _c("div", [_vm._v(_vm._s(scope.row.driverName) + " " + _vm._s(scope.row.driverCarNumber))]) : _vm._e(), scope.row.handleUserType == "mng_user_category_hd_motorcade" ? _c("div", [_vm._v("接单方:" + _vm._s(scope.row.userNickname) + " " + _vm._s(scope.row.userPhone))]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "createTime",
      label: "创建时间",
      sortable: "custom",
      width: "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_vm._v(_vm._s(scope.row.createTime ? _vm.dayjs(scope.row.createTime * 1000).format("YYYY-MM-DD HH:mm:ss") : ""))])];
      }
    }])
  })], 1), _c("el-pagination", {
    attrs: {
      background: "",
      align: "center",
      layout: "prev, pager, next, sizes, total",
      "page-sizes": [10, 20, 50, 100],
      "current-page": _vm.searchForm.page,
      "page-size": _vm.searchForm.limit,
      total: _vm.totalCount
    },
    on: {
      "current-change": _vm.pageChange,
      "size-change": _vm.sizeChange
    }
  }), _c("el-dialog", {
    attrs: {
      visible: _vm.editDialogShow,
      title: _vm.editDialogTitle,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.editDialogShow = $event;
      },
      close: function close($event) {
        return _vm.initFormData(_vm.emptyFormData);
      }
    }
  }, [_c("el-form", {
    ref: "formDataVerify",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 24
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "操作前内容",
      "label-width": _vm.formLabelWidth,
      prop: "userNickname"
    }
  }, [_c("div", {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.jsonToContent(_vm.formData.oldContent)))])])], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 24
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "操作后内容",
      "label-width": _vm.formLabelWidth,
      prop: "userNickname"
    }
  }, [_c("div", {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.jsonToContent(_vm.formData.newContent)))])])], 1)], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.closeEditDialogShow
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };